import React from "react";
import { CheckCircle2 } from "lucide-react";
import PublicLayout from "../components/PublicLayout";
import { useI18n } from "../i18n/I18nContext";
import { useSite } from "../context/SiteContext";

export default function About() {
    const { t, lang } = useI18n();
    const { site } = useSite();
    const a = site?.about || {};
    const clientsCount = site?.clients_satisfied ?? 500;

    const kicker = lang === "en" ? a.kicker_en : a.kicker_fr;
    const title = lang === "en" ? a.title_en : a.title_fr;
    const text_1 = lang === "en" ? a.text_1_en : a.text_1_fr;
    const text_2 = lang === "en" ? a.text_2_en : a.text_2_fr;
    const values_title = lang === "en" ? a.values_title_en : a.values_title_fr;
    const values = (lang === "en" ? a.values_en : a.values_fr) || [];
    const image = a.image_url || "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200";

    return (
        <PublicLayout>
            <section className="bg-brand-navy text-white" data-testid="about-hero">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
                    <div className="text-[0.7rem] tracking-[0.3em] uppercase font-semibold text-brand-gold mb-3">
                        {kicker || t("about.kicker")}
                    </div>
                    <h1 className="font-display text-5xl sm:text-6xl">{title || t("about.title")}</h1>
                </div>
            </section>
            <section className="py-20 bg-brand-paper">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 items-start">
                    <div className="lg:col-span-7 space-y-5 text-gray-700 leading-relaxed text-lg">
                        <p>{text_1 || t("about.text_1")}</p>
                        <p>{text_2 || t("about.text_2")}</p>
                        <div className="pt-4">
                            <h3 className="font-display text-2xl text-brand-navy mb-4">{values_title || t("about.values_title")}</h3>
                            <ul className="space-y-3">
                                {values.map((v) => (
                                    <li key={v} className="flex items-start gap-3 text-base text-gray-700">
                                        <CheckCircle2 className="w-5 h-5 text-brand-emerald flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                                        <span>{v}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="lg:col-span-5 relative" data-testid="about-image">
                        <img src={image} alt="Villa" className="w-full aspect-[4/5] object-cover" />
                        <div className="absolute -bottom-6 -left-6 bg-brand-gold text-white p-6 hidden md:block">
                            <div className="font-display text-3xl">+{clientsCount}</div>
                            <div className="text-[0.68rem] tracking-[0.22em] uppercase font-semibold">
                                {t("why.satisfied")}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </PublicLayout>
    );
}
